import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CONSENT_EVENT, needsConsent, setConsent } from "@/lib/fbPixel";

/** « Accepter / Refuser » for the ads measurement (Meta pixel) — shown only where the law asks
 * for it and only once a pixel is configured (see lib/fbPixel.js). Never covers the player or
 * the bottom menu for long: one tap and it is gone. */
export default function CookieBanner() {
  const [show, setShow] = useState(needsConsent);
  useEffect(() => {
    const again = () => setShow(needsConsent());
    window.addEventListener(CONSENT_EVENT, again);
    return () => window.removeEventListener(CONSENT_EVENT, again);
  }, []);
  if (!show) return null;
  const answer = (yes) => { setConsent(yes); setShow(false); };

  return (
    <div className="fixed inset-x-0 bottom-0 z-[90] p-3 sm:p-4" data-testid="cookie-banner">
      <div className="max-w-3xl mx-auto bg-zinc-950/95 backdrop-blur-xl border border-white/15 rounded-2xl p-4 shadow-2xl sm:flex sm:items-center sm:gap-4">
        <p className="text-sm text-zinc-300 leading-relaxed flex-1">
          Metazik utilise un outil de Facebook pour savoir si ses publicités marchent (une visite, une inscription
          ou un achat venant d'une pub). Aucun paiement, numéro de téléphone ni écoute n'est envoyé.{" "}
          <Link to="/privacy" className="underline text-white">En savoir plus</Link>
        </p>
        <div className="flex gap-2 mt-3 sm:mt-0 shrink-0">
          <button type="button" onClick={() => answer(false)} className="btn-secondary px-4" data-testid="cookie-refuse">Refuser</button>
          <button type="button" onClick={() => answer(true)} className="btn-primary px-4" data-testid="cookie-accept">Accepter</button>
        </div>
      </div>
    </div>
  );
}
